module.exports = __webpack_public_path__ + "img/speed-map-china.792a1f52.png";